module.exports = __webpack_public_path__ + "media/1x1/ma-bee9c054.svg";